import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logVisitor } from '../../services';

/**
 * Custom hook to track visitor page views
 * Logs initial visit and subsequent route changes
 */
export function useVisitorTracking(enabled = true) {
  const location = useLocation();

  useEffect(() => {
    // Disable tracking in development / localhost
    if (
      !enabled ||
      import.meta.env.DEV ||
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      return;
    }

    logVisitor();
  }, [enabled, location.pathname, location.search]);
}
